// extracted by css-extract-rspack-plugin
export default {"cls1":"Loading-cls1_UqF","cls2":"Loading-cls2_uqW Loading-cls1_UqF"};